const ONE_SECOND_MS = 1000;
const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;
const ONE_DAY_MS = 1440 * ONE_MINUTE_MS;

/**
 * Common time calcs
 *
 * Values are represented in milliseconds
 * unless stated otherwise in the name.
 */
export enum TimeEnum {
  TwoMinutes = 2 * ONE_MINUTE_MS,
  TwoSeconds = 2 * ONE_SECOND_MS,
  FiveMinutes = 5 * ONE_MINUTE_MS,
  FiveMinutesInSeconds = (5 * ONE_MINUTE_MS) / 1000,
  FiveSeconds = 5 * ONE_SECOND_MS,
  TenMinutes = 10 * ONE_MINUTE_MS,
  TenMinutesInSeconds = (10 * ONE_MINUTE_MS) / 1000,
  TenSeconds = 10 * ONE_SECOND_MS,
  TwentyMinutes = 20 * ONE_MINUTE_MS,
  ThirtySeconds = 30 * ONE_SECOND_MS,
  OneDay = ONE_DAY_MS,
  OneDayInSeconds = ONE_DAY_MS / 1000,
  OneHourInSeconds = 3600,
  TwelveHours = 12 * 60 * ONE_MINUTE_MS,
  TwelveHoursInSeconds = 43200,
  OneMinute = ONE_MINUTE_MS,
  OneMinuteInSeconds = ONE_MINUTE_MS / 1000,
  OneSecond = ONE_SECOND_MS,
  OneWeek = 7 * ONE_DAY_MS,
  OneWeekInSeconds = (7 * ONE_DAY_MS) / 1000,
}
